import { Menu } from 'react-feather';
import { Logo } from './Logo';
import { SideNavigation } from './SideNavigation';
import { useState, useEffect } from 'react';
import clsx from 'clsx';

export const Sidebar = () => {
  const [expanded, setExpanded] = useState(true); // User-expanded
  const [hovered, setHovered] = useState(false); // Auto-expand on hover

  // Auto-collapse on small screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sidebarOpen = expanded || hovered;

  return (
    <aside
      className={clsx(
        'hidden md:flex flex-shrink-0 transition-all duration-300 bg-[#26232d] shadow-xl z-40'
      )}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className={clsx(
          'flex flex-col transition-all duration-500 ease-in-out',
          sidebarOpen ? 'w-64' : 'w-20'
        )}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 h-16">
          {sidebarOpen ? <Logo size={36} /> : <div className="flex justify-center w-full"></div>}
          <button
            onClick={() => setExpanded(!expanded)}
            className="p-2 rounded-md hover:bg-gray-700 transition focus:outline-none focus:ring-2 focus:ring-[#AE3F1E]/60"
          >
            <Menu
              className={clsx(
                'h-6 w-6 text-gray-300 transition-transform duration-300',
                !sidebarOpen && 'rotate-180'
              )}
            />
          </button>
        </div>

        {/* Navigation */}
        <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-900">
          <nav
            className={clsx(
              'flex-1 px-2 py-4 transition-all duration-300',
              sidebarOpen ? 'pl-4 pr-2' : 'px-2'
            )}
          >
            <SideNavigation showLabels={sidebarOpen} />
          </nav>
        </div>

        {/* Footer */}
        <div
          className={clsx(
            'h-16 flex items-center justify-center transition-all duration-300',
            sidebarOpen ? 'px-4' : 'px-0'
          )}
        >
          {sidebarOpen ? (
            <p className="text-gray-500 text-xs">© Ayinza CMS 2025</p>
          ) : (
            <div className="w-2 h-2 bg-gray-600 rounded-full" />
          )}
        </div>
      </div>
    </aside>
  );
};
